/*
 * @Desc: 
 * @Author: 赵佳明
 * @Date: 2023-02-25 08:57:16
 * @LastEditors: 赵佳明
 * @LastEditTime: 2023-02-25 14:04:35
 * Copyright (c) 2023 山木枝(河北)技术服务有限公司, All Rights Reserved. 
 */
import { createApp } from 'vue'
// import App from './App.vue'
// 首页模板
import App from './components/page/App.vue'
import router from './router'
import store from './store'
import Vant, {} from 'vant'
import 'vant/lib/index.css'
import VConsole from 'vconsole';
// 各API接口
import api from './api/api' // 导入api接口

let app = createApp(App).use(store).use(router)
app.use(Vant)
app.config.globalProperties.$api = api
// app.config.globalProperties.$imgurl = 'http://hsbaoshe2.oss-cn-beijing.aliyuncs.com/'
app.config.globalProperties.$imgurl = 'https://ycspeaker.oss-cn-beijing.aliyuncs.com/'
if (location.origin == 'https://speaker.shanmuzhi.com' || location.origin.indexOf('localhost') != -1) {
  app.config.globalProperties.$publicData = {
    shareTitle: '我的运城：我为家乡发声', //分享标题
    shareDesc: '打通宣传的最后一公里，让信息触达更多人。', //分享描述
    shareImg: 'https://speaker.shanmuzhi.com/speakerh5/statics/images/share.jpg', //分享图片
    domain: 'https://speaker.shanmuzhi.com/',  //二次分享拼链接用
    followImg: 'https://speaker.shanmuzhi.com/speakerh5/statics/images/follow.jpg', //关注图片
  }
  const vConsole = new VConsole();
} else {
  app.config.globalProperties.$publicData = {
    shareTitle: '我的运城：我为家乡发声', //分享标题
    shareDesc: '打通宣传的最后一公里，让信息触达更多人。', //分享描述
    shareImg: 'https://ycspeaker.shanmuzhi.com/speakerh5/statics/images/share.jpg',//分享图片
    domain: 'https://ycspeaker.shanmuzhi.com/',//二次分享拼链接用
    followImg: 'https://ycspeaker.shanmuzhi.com/speakerh5/statics/images/follow.jpg', //关注图片
  }
}
//  v-authCheck="{ type: 1 }"
app.directive('authCheck', {
  // 指令具有一组生命周期钩子：
  // 在绑定元素的 attribute 或事件监听器被应用之前调用
  created() {},
  // 在绑定元素的父组件挂载之前调用
  beforeMount() {},
  // 在绑定元素的父组件挂载之后调用
  mounted(el,binding,vnode) {
    // console.log(el)
    // console.log(binding.instance.$store)
    // console.log(binding.value.type)
    // let priv = JSON.parse(localStorage.getItem('priv')) || []
    // if(priv.length>0){
    //   let arr = []
    //   priv.forEach(function(item,idx){
    //     arr.push(item.right.id)
    //   })
    //   console.log(arr)
    //   console.log('------')
    //   console.log(arr.indexOf(binding.value.type))
    //   if (arr.indexOf(binding.value.type) != -1){
    //     console.log('显示')
    //     el.style.display = 'block'
    //   } else {
    //     console.log('隐藏')
    //     el.style.display = 'none'
    //   }
    // }
  },
  // 在包含组件的 VNode 更新之前调用
  beforeUpdate() {},
  // 在包含组件的 VNode 及其子组件的 VNode 更新之后调用
  updated() {},
  // 在绑定元素的父组件卸载之前调用
  beforeUnmount() {},
  // 在绑定元素的父组件卸载之后调用
  unmounted() {}
})
app.mount('#app')
